import { type TFunction } from 'react-i18next';
import { type ModuleWithPermissionsSpecsFragment } from '../../../../api/fragments/ModuleWithPermissionsSpecs';
import * as implementations from './implementations';
import { type ModuleImplementation } from './implementations/types';

export const renderPage = (module: ModuleWithPermissionsSpecsFragment) => {
    const { PageComponent } = implementations[module.__typename] as ModuleImplementation<
        ModuleWithPermissionsSpecsFragment,
        any
    >;

    return <PageComponent module={module} />;
};

export const getTitle = (module: ModuleWithPermissionsSpecsFragment, t: TFunction) =>
    getTitleForType(module.__typename, t);

export const getTitleForType = (moduleType: keyof typeof implementations, t: TFunction) =>
    implementations[moduleType].getTitle(t);

export { implementations };
